/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="mc-form-carpool-recap">
    <div class="mc-recap-item">
      <div
        class="mc-recap-header d-flex flex-wrap justify-between align-center"
        v-if="type != 'askCarpool'"
      >
        <div v-if="recapCarpool.frequency == 2" class="d-flex flex-wrap">
          <div v-for="(day, index) in recapCarpool.regularDays" :key="index">
            <div class="mc-pastille-day" v-bind:class="{ 'selected': day.value }">
              <b>{{$t(day.trad)}}</b>
            </div>
          </div>
        </div>
        <span>{{ outwardDate }}</span>
        <div class="d-flex align-center" v-if="recapCarpool.driver">
          <div>{{recapCarpool.priceCarpool}} €</div>
          <ion-icon v-if="recapCarpool.passenger" color="secondary" class="price-info" @click="priceInfo()" name="information-circle-outline"></ion-icon>
        </div>
      </div>
      <div
        v-if="recapCarpool.frequency == 1 && (!!recapCarpool.outwardTime || !!recapCarpool.returnTime)"
        class="mc-carpool-subheader d-flex justify-around align-center"
      >
        <div v-if="recapCarpool.outwardTime" class="d-flex align-center mc-carpool-regular-time">
          <ion-icon name="arrow-down"></ion-icon>
          <span>{{ $t('Carpool.oneWay') }}</span>
          <span class="time">{{ recapCarpool.outwardTime.length > 5 ? moment(recapCarpool.outwardTime , 'HH[:]mm') : recapCarpool.outwardTime  }}</span>
        </div>
        <div
          v-if="recapCarpool.returnTime"
          class="d-flex align-center mc-carpool-regular-time"
        >
          <ion-icon name="arrow-up"></ion-icon>
          <span>{{ $t('Carpool.return') }}</span>
          <span class="time">{{ recapCarpool.returnTime.length > 5 ? moment(recapCarpool.returnTime , 'HH[:]mm') : recapCarpool.returnTime }}</span>
        </div>
      </div>
      <div
        v-if="recapCarpool.frequency == 2"
        class="mc-carpool-subheader d-flex justify-around align-center"
      >
        <div
          v-if="recapCarpool.isMultipleTime"
          class="d-flex align-center mc-carpool-regular-time"
        >Horaires différents selon les jours</div>
        <div
          v-if="!recapCarpool.isMultipleTime && recapCarpool.outwardTime"
          class="d-flex align-center mc-carpool-regular-time"
        >
          <ion-icon name="arrow-down"></ion-icon>
          <span>{{ $t('Carpool.oneWay') }}</span>
          <span class="time">{{ recapCarpool.outwardTime }}</span>
        </div>

        <div
          v-if="!recapCarpool.isMultipleTime && recapCarpool.returnTime"
          class="d-flex align-center mc-carpool-regular-time"
        >
          <ion-icon name="arrow-up"></ion-icon>
          <span>{{ $t('Carpool.return') }}</span>
          <span class="time">{{ recapCarpool.returnTime }}</span>
        </div>
      </div>
      <div class="mc-recap-step d-flex">
        <div class="mc-carpool-info-image d-flex flex-col">
          <div v-if="recapCarpool.driver" class="mc-carpool-driver">
            <ion-icon size="large" name="car"></ion-icon>
          </div>
          <div v-if="recapCarpool.passenger" class="mc-carpool-passenger">
            <ion-icon size="large" name="walk"></ion-icon>
          </div>
        </div>

        <div class="timeline-container d-flex flex-col">
          <p
            class="timeline text-left d-flex align-center"
            v-for="(step, index) in recapCarpool.outwardWaypoints"
            :key="index"
          >
            <span v-if="!(step.role && step.type)" class="dot"></span>
            <ion-icon
              v-if="step.role && step.type"
              :name="getIconStepName(step).name"
              class="mc-step-icon"
              :class="getIconStepName(step).background"
            ></ion-icon>
            <span v-html="displayStep(step)"></span>
          </p>
        </div>
      </div>

      <div class="mc-recap-footer d-flex ion-justify-content-between ion-align-items-center" v-if="!!recapCarpool.seats && type != 'askCarpool' && recapCarpool.driver">
        <div>
          {{$t('Carpool.seats')}}
          <div class="d-flex">
            <ion-icon v-for="index in parseInt(recapCarpool.seats)" :key="index" name="person">{{index}}</ion-icon>
          </div>
        </div>
        <div v-if="rdex">
          {{recapCarpool.externalOrigin}}
        </div>

      </div>
    </div>

    <div v-if="!!recapCarpool.comment" class="mc-recap-message ion-margin-top">{{recapCarpool.comment}}</div>

    <ion-card style="margin-right: 0px; margin-left: 0px; border-radius: 20px" color="secondary" v-if="(recapCarpool.detourDistancePercent || recapCarpool.detourDurationPercent ) && (recapCarpool.detourDistancePercent > 10 || recapCarpool.detourDurationPercent > 10)">
      <ion-card-content class="d-flex align-center">
        <span class="mdi mdi-clock mdi-24px ion-margin-end" ></span>
        <div style="font-size: 18px;">Ce trajet calculé comporte un détour.</div>
      </ion-card-content>
    </ion-card>

    <div class="mc-recap-user" v-if="!!recapCarpool.user && type != 'askCarpool'">
      <div class="mc-recap-user-bloc-info">
        <div class="mc-user-image position-relative">
          <ion-thumbnail v-if="!! recapCarpool.user.avatars">
            <img v-if="checkAvatarDefault" alt="" :src="webURL + recapCarpool.user.avatars[0]" />
            <img v-else :src="recapCarpool.user.avatars[0]" alt="" />
          </ion-thumbnail>
          <ion-icon v-if="showExperienced && recapCarpool.user.experienced" class="experienced" name="star"></ion-icon>
        </div>

        <div class="mc-recap-user-info">
          <div>
            {{recapCarpool.user.givenName }} {{recapCarpool.user.shortFamilyName }}
            <!-- Verified Identity -->
            <div v-if="verifiedIdentity && recapCarpool.user.verifiedIdentity" class="mc-verified-identity">
              <svg height="20px" viewBox="0 0 24 24" width="20px"><g>
                <path fill="var(--ion-color-success)" d="M13,13c0,1,0.5,1.8,1.2,2.4C12.3,16.1,11,17.9,11,20h10c0-2.1-1.3-3.9-3.2-4.6C18.5,14.8,19,14,19,13c0-1.7-1.3-3-3-3   S13,11.3,13,13z M19.9,19h-7.7c0.4-1.7,2-3,3.9-3S19.4,17.3,19.9,19z M18,13c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S18,11.9,18,13z"/>
                <rect fill="var(--ion-color-success)" height="1" width="5" x="4" y="17"/>
                <rect fill="var(--ion-color-success)" height="1" width="5" x="4" y="15"/>
                <rect fill="var(--ion-color-success)" height="1" width="5" x="4" y="13"/>
                <path fill="var(--ion-color-success)" d="M23,6h-9V3c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1v3H1C0.4,6,0,6.4,0,7v16c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V7   C24,6.4,23.6,6,23,6z M11,3h2v6h-2V3z M22,22H2V8h8v1c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V8h8V22z"/></g>
              </svg>
            </div>
          </div>
          <div>
          <ion-button
            v-if="recapCarpool.user.id && !rdex"
            class="mc-small-button"
            color="primary"
            fill="outline"
            @click="$router.push({name : 'profile-public', params : {id: recapCarpool.user.id }})"
          >
            <ion-icon name="eye"></ion-icon>
            <span class="ion-margin-start">{{ $t('Commons.see') }}</span>
          </ion-button>
          </div>
        </div>
      </div>
    </div>

    <div class="mc-carpool-map" v-if="type != 'askCarpool' && !rdex">
      <l-map
        v-if="showCard"
        :ref="'mapRecap'"
        style="height: 350px"
        :center="center"
        :zoom="zoom"
        :bounds="bounds"
        :options="optionsCard"
      >
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-polyline v-if="recapCarpool.directPoints" :lat-lngs="recapCarpool.directPoints" :color="getColorSecondary()"></l-polyline>
        <l-marker v-if="recapCarpool.outwardWaypoints[0]" :lat-lng="[recapCarpool.outwardWaypoints[0].latitude, recapCarpool.outwardWaypoints[0].longitude]">
          <l-icon :iconSize="[30, 42]" :iconAnchor="[15, 42]" className="custom-div-icon"><div class="marker-pin marker-pin-secondary"></div><ion-icon name="home"></ion-icon></l-icon>
        </l-marker>
        <l-marker v-if="recapCarpool.outwardWaypoints[recapCarpool.outwardWaypoints.length - 1]" :lat-lng="[recapCarpool.outwardWaypoints[recapCarpool.outwardWaypoints.length - 1].latitude, recapCarpool.outwardWaypoints[recapCarpool.outwardWaypoints.length - 1].longitude]">
          <l-icon :iconSize="[30, 42]" :iconAnchor="[15, 42]" className="custom-div-icon"><div class="marker-pin marker-pin-secondary"></div><ion-icon name="flag"></ion-icon></l-icon>
        </l-marker>
        <l-marker v-if="getPassengerOrigin()" :lat-lng="[getPassengerOrigin().latitude, getPassengerOrigin().longitude]">
          <l-icon :iconSize="[30, 42]" :iconAnchor="[15, 42]" className="custom-div-icon"><div class="marker-pin"></div><ion-icon name="person"></ion-icon></l-icon>
        </l-marker>
        <l-marker v-if="getPassengerDestination()" :lat-lng="[getPassengerDestination().latitude, getPassengerDestination().longitude]">
          <l-icon :iconSize="[30, 42]" :iconAnchor="[15, 42]" className="custom-div-icon"><div class="marker-pin"></div><ion-icon name="flag"></ion-icon></l-icon>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<style lang="scss">
.mc-form-carpool-recap {
  margin-top: 20px;

  .mc-pastille-day {
    background: white;
    color: rgba(var(--ion-color-primary-rgb), 0.5);
    font-weight: bold;
    font-size: 14px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    margin-bottom: 5px;

    &.selected {
      background: rgba(var(--ion-color-primary-rgb), 0.5);
      color: white;
    }
  }

  .mc-step-icon {
    border-radius: 50%;
    padding: 4px;
    color: white;
    margin-right: 10px;
    min-width: 16px;

    &.active {
      font-size: 22px;
      margin-left: -3px;
      min-width: 22px
    }
  }

  .mc-icon-step-background-primary {
    background-color: var(--ion-color-primary);
  }

  .mc-icon-step-background-secondary {
    background-color: var(--ion-color-secondary);
  }

  .mc-icon-step-background-green {
    background-color: #13a569;
  }

  .mc-carpool-subheader {
    background: rgba(255, 255, 255, 0.5);
    color: var(--ion-color-primary);
    height: 50px;

    .mc-carpool-regular-time {
      font-weight: bold;

      span {
        padding-right: 10px;

        &.time {
          font-weight: lighter;
          color: rgba(var(--ion-color-primary-rgb), 0.7);
        }
      }
    }
  }

  .mc-carpool-info-image {
    margin-right: 10px;

    .mc-carpool-driver {
      flex: 1;
      justify-content: center;
      align-items: center;
      width: 40px;
      display: flex;
      background: var(--ion-color-success);
      color: white;
    }

    .mc-carpool-passenger {
      flex: 1;
      justify-content: center;
      align-items: center;
      width: 40px;
      display: flex;
      background: var(--ion-color-primary);
      color: white;
    }
  }

  .mc-recap-item {
    background: rgba(var(--ion-color-primary-rgb), 0.1);
    border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);
    border-radius: 20px;
    overflow: hidden;

    .mc-recap-header {
      padding: 10px;
      color: var(--ion-color-primary);
      font-weight: bold;
    }

    .mc-recap-step {
      background: white;
      color: var(--ion-color-primary);

      .timeline-container{
        position: relative;
      }

      .timeline-container::before {
        content: "";
        position: absolute;
        margin: auto;
        width: 1px;
        background-color: lightgrey;
        top: 7px;
        bottom: 7px;
        left: 11px;
      }

      .dot {
        width: 12px;
        height: 12px;
        border-radius: 6px;
        background-color: var(--ion-color-primary);
        margin-left: 5px;
        margin-right: 10px;
      }

      .timeline {
        position: relative;
        //padding-left: 20px;

        /*
        &::before {
          content: "";
          position: absolute;
          margin: auto;
          width: 12px;
          height: 12px;
          border-radius: 6px;
          background-color: var(--ion-color-primary);
          top: 0px;
          bottom: 0;
          left: 0px;
        }
         */
      }
    }

    .mc-recap-footer {
      color: var(--ion-color-primary);
      padding: 10px;
    }
  }

  .mc-recap-message {
    background: #f5f6fa;
    padding: 10px;
    color: rgba(0, 0, 0, 0.6);
    border-radius: 15px 15px 15px 0px;
    margin-bottom: 20px;
    white-space: pre-line;
  }

  .mc-recap-user {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: 45px;

    .mc-recap-user-bloc-info {
      color: var(--ion-color-primary);
      display: flex;
      width: 100%
    }

    ion-thumbnail {
      --size: 90px;
      --border-radius: 50%;
    }

    .mc-recap-user-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 20px;
      width: 100%;
      flex-wrap: wrap;
      font-weight: bold;
    }
  }

  .price-info {
    cursor: pointer;
    font-size: 20px;
    margin-left: 5px;
  }

  .mc-verified-identity {
    margin-left: 10px;
    display: inline-block
  }
}
</style>

<script>
import { LMap, LTileLayer, LPolyline, LMarker, LIcon } from "@vue-leaflet/vue-leaflet";
import { isPlatform } from "@ionic/core";
import {toast} from "../../../Shared/Mixin/toast.mixin";
import {address} from "../../../Shared/Mixin/address.mixin";
import {LatLngBounds} from "leaflet";

export default {
  name: "recap-carpool",
  mixins: [toast, address],
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      center: [47.2350952, 2.0426357],
      zoom: 8,
      showCard: true,
      optionsCard: {
        dragging: !isPlatform(window.document.defaultView, "mobile"),
        touchZoom: isPlatform(window.document.defaultView, "mobile"),
        tap: !isPlatform(window.document.defaultView, "mobile")
      },
      showExperienced: JSON.parse(process.env.VUE_APP_EXPERIENCED),
      showReviews: JSON.parse(process.env.VUE_APP_REVIEWS),
      verifiedIdentity: JSON.parse(process.env.VUE_APP_VERIFIED_IDENTITY),
      webURL: process.env.VUE_APP_WEB_URL
    };
  },
  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LMarker,
    LIcon
  },
  props: ["recap", "type", "rdex"],
  mounted() {
    setTimeout(() => {
      // if (!!this.$refs.mapRecap) this.$refs.mapRecap.leafletObject.invalidateSize();
      this.setBounds()
    }, 1000);
  },
  computed: {
    bounds() {
      const bounds = new LatLngBounds(this.recap.directPoints);
      if (!!this.$refs.mapRecap && !!this.$refs.mapRecap.leafletObject) {
        this.$refs.mapRecap.leafletObject.invalidateSize();
      }
      return bounds;
    },

    recapCarpool() {
      return this.recap
    },

    checkAvatarDefault() {
      const path = this.recapCarpool.user.avatars;
      const avatarDefaultPath = '/images/avatarsDefault/square_100.svg'
      if (path.includes(avatarDefaultPath)) {
        return true;
      }
    },
    outwardDate(){
      if(!this.recapCarpool.outwardDate) {
        return this.$moment.utc(this.recapCarpool.startDate).format('DD MMMM YYYY')
      }
      return this.$moment.utc(this.recapCarpool.outwardDate).format( 'DD MMMM YYYY')
    }
  },
  methods: {
    setBounds() {
      let bounds;
      bounds = new LatLngBounds(this.recap.directPoints);
      if (!!this.$refs.mapRecap && !!this.$refs.mapRecap.leafletObject) {
        try{
          this.$refs.mapRecap.leafletObject.fitBounds(bounds);
          // console.log(bounds.getCenter())
          this.$refs.mapRecap.leafletObject.invalidateSize();
        } catch (err) {
          console.log(err)
        }
      }
      return bounds;
    },
    priceInfo() {
      this.presentToast(this.$t("PostCarpool.price-info"), "secondary");
    },
    displayStep(step) {
      let result = "";
      if (!!step.time) {
        result = `<b>${this.$moment(step.time)
          .utc()
          .format("HH[h]mm")}</b>: `;
      }
      result += this.formatAddress(step);
      /*
      if (!!step.displayLabel && step.displayLabel[0] && step.displayLabel[1]) {
        result += `${step.displayLabel[0]}`;
      } else {
        if (!!step.addressCountry) {
          result += `${step.addressLocality},  ${step.addressCountry}`;
        } else {
          result += `${step.addressLocality}`;
        }
      }
       */
      return result;
    },

    getIconStepName(step) {
      switch (step.type) {
        case "origin":
          if (step.role == "driver") {
            return {
              name: "home",
              background: "mc-icon-step-background-secondary" + (this.recapCarpool.passenger ? ' active' : '')
            };
          } else {
            return {
              name: "person",
              background: "mc-icon-step-background-primary" + (this.recapCarpool.driver ? ' active' : '')
            };
          }
          break;

        case "destination":
          if (step.role == "driver") {
            return {
              name: "flag",
              background: "mc-icon-step-background-secondary" + (this.recapCarpool.passenger ? ' active' : '')
            };
          } else {
            return {
              name: "flag",
              background: "mc-icon-step-background-primary" + (this.recapCarpool.driver ? ' active' : '')
            };
          }

        case "step":
          if (step.role == "driver") {
            return {
              name: "pin",
              background: "mc-icon-step-background-secondary"
            };
          } else {
            return {
              name: "pin",
              background: "mc-icon-step-background-primary"
            };
          }
          break;
        default:
          break;
      }
    },

    getPassengerOrigin() {
      return this.recapCarpool.outwardWaypoints.find(item => item.type == 'origin' && item.role == 'passenger')
    },

    getPassengerDestination() {
      return this.recapCarpool.outwardWaypoints.find(item => item.type == 'destination' && item.role == 'passenger')
    },

    getColorSecondary() {
      return document.documentElement.style.getPropertyValue('--ion-color-secondary');
    }
  }
};
</script>
